import { Box, Skeleton } from '@mui/material';

import { ITimelineItem } from '@clients/timelineClient';
import TimelineItemTemplate from '@components/accountTimeline/accountTimelineBlock/TimelineItemTemplate';

export type TimelineItemSkeletonProps = {
    timelineItem: ITimelineItem;
    panelMode?: boolean;
};

const TimelineItemSkeleton = ({
    timelineItem,
    panelMode = false,
}: TimelineItemSkeletonProps) => {
    return (
        <TimelineItemTemplate
            key={timelineItem.timestamp}
            avatar={
                <Box
                    sx={{
                        bgcolor: 'background.paper',
                    }}>
                    <Skeleton variant="circular" width={40} height={40} />
                </Box>
            }
            testId="timelineitem-skeleton"
            primaryTitle={<Skeleton width={100} />}
            primarySubtitle={<Skeleton width={100} />}
            secondaryTitle={<Skeleton width={100} />}
            secondarySubtitle={<Skeleton width={100} />}
            highlightOnHover={false}
            urlToNavigateTo=""
            panelMode={panelMode}
        />
    );
};

export default TimelineItemSkeleton;
